var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIcAlertWarning = function SvgIcAlertWarning(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.14282 17C5.14282 10.4514 10.4514 5.14282 17 5.14282C23.5485 5.14282 28.8571 10.4514 28.8571 17C28.8571 23.5485 23.5485 28.8571 17 28.8571C10.4514 28.8571 5.14282 23.5485 5.14282 17Z",
    strokeWidth: 2
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.57153 17.0001C1.57153 8.47914 8.47914 1.57153 17.0001 1.57153C25.5211 1.57153 32.4287 8.47914 32.4287 17.0001C32.4287 25.5211 25.5211 32.4287 17.0001 32.4287C8.47914 32.4287 1.57153 25.5211 1.57153 17.0001Z",
    strokeWidth: 2
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1388_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 13.6667V17.0001M17.0001 20.3334H17.0084M25.3334 17.0001C25.3334 21.6025 21.6025 25.3334 17.0001 25.3334C12.3977 25.3334 8.66675 21.6025 8.66675 17.0001C8.66675 12.3977 12.3977 8.66675 17.0001 8.66675C21.6025 8.66675 25.3334 12.3977 25.3334 17.0001Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1388_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(7 7)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIcAlertWarning);
export default ForwardRef;